import { render, staticRenderFns } from "./Seguros.vue?vue&type=template&id=51d5e819"
import script from "./Seguros.vue?vue&type=script&lang=js"
export * from "./Seguros.vue?vue&type=script&lang=js"
import style0 from "./Seguros.vue?vue&type=style&index=0&id=51d5e819&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports